// src/pages/RubricSessionsList.js
import { useAuth } from "../../context/AuthContext";
import { FaFlagCheckered } from "react-icons/fa";
import RubricSessionsTable from "../../components/rubrics/RubricSessionsTable";
import PageBanner from "../../components/common/PageBanner";

const RubricSessionsList = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <div>Please log in to view reports</div>;
  }

  return (
    <div className="py-6 px-10">
      <PageBanner
        icon={<FaFlagCheckered />}
        title="Generate Rubrics"
        description="Create rubrics by selecting the mapped competencies from your completed sessions."
      >
        <p className="mt-2 font-semibold text-red-500 text-xs">
          Warning: You may only generate a maximum of 3 rubrics per completed sessions!
        </p>
      </PageBanner>

      <RubricSessionsTable userId={currentUser.id} />
    </div>
  );
};

export default RubricSessionsList;